'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var VISIBILITY = exports.VISIBILITY = {
  NOT_VISIBLE: 'not_visible',
  LINK: 'visible_by_link',
  GEOFENCED: 'geofenced',
  EVERYWHERE: 'visible_everywhere'
};

var MAX_LIST_ITEMS = exports.MAX_LIST_ITEMS = 100;

var LIST_NAME_LENGTH_SOFT_LIMIT = exports.LIST_NAME_LENGTH_SOFT_LIMIT = 140;
var LIST_DESCRIPTION_LENGTH_SOFT_LIMIT = exports.LIST_DESCRIPTION_LENGTH_SOFT_LIMIT = 2000;

exports.default = {
  MAX_LIST_ITEMS: MAX_LIST_ITEMS,
  VISIBILITY: VISIBILITY,
  LIST_NAME_LENGTH_SOFT_LIMIT: LIST_NAME_LENGTH_SOFT_LIMIT,
  LIST_DESCRIPTION_LENGTH_SOFT_LIMIT: LIST_DESCRIPTION_LENGTH_SOFT_LIMIT
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/constants-list/lib/index.js
// module id = 1405
// module chunks = 1